import { Breadcrumbs } from "components/breadcrumbs";
import React from 'react';
import { EventType } from "interfaces";
import { ImportParticipant } from "../components";

export const MassImportSportParticipant: React.FC = () => {      
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create & Update Sport participant" />
      <ImportParticipant eventType={EventType.SPORT} />
    </div>
  );
};
